import Task from "./models/task";
import TaskQueryService from "../entities/task-query-service";
import formatDate from "@/helpers/formatDate";

export default class TaskService {
  public constructor(private tasks: TaskQueryService) {}

  public async search(
    date: Date,
    hiddenDoneTasks: boolean = false,
    orderBy: string = ""
  ): Promise<TaskQueryResponse> {
    const tasks = hiddenDoneTasks
      ? await this.tasks.undone(orderBy)
      : await this.tasks.all(orderBy);
    return tasks.map(t => ({
      ...t,
      id: String(t.id),
      dueDate: t.dueDate ? formatDate(t.dueDate) : "",
      overdue: t.isOverdue(date)
    }));
  }
}

type TaskQueryResponse = Task[];
